export enum SIZES {
  md,
  sm,
}

export enum SHAPES {
  square,
  rounded,
}
